import CityPageTemplate from "../city-template/CityPageTemplate";
import { versaillesConfig } from "./data";

export default function VersaillesPage() {
  return <CityPageTemplate config={versaillesConfig} />;
}